const portfolios = [
    {
      id: 1,
      location: "BOLIVIA",
      company: "Taller",
      description: "Se realizo una campaña publicitaria de moda inspirada en realzar el poder y la esencia de cada persona. El resultado es el empoderamiento al utilizar las prendas, permitiéndo expresar su propia personalidad con estilo.",
      elenco: ["Pamela Ahenke (Fotografia y direccíon creativa)", "Thiago Andrade (Edicíon y actuacíon)"],  // This is an example.
      services: ["Audiovisual"]
    },
    {
      id: 2,
      location: "ALEMANIA",
      company: "Titus",
      description: "Se realizó la campaña publicitaria para la marca Alemana ''Titus'' , una marca de moda Urbana y zapatillas de Skate que lanzaron una bolsa roja , un accesorio esencial para cada skater , quisimos demostrar eso en la campaña dando a entender que es un accesorio de uso diario.",
      elenco: ["Pamela Ahenke (Fotografia y direccíon creativa)", "Thiago Andrade (Edicíon y actuacíon)"],  // This is an example.
      services: ["Audiovisual"]
    },
    {
      id: 3,
      location: "BOLIVIA",
      company: "Walawa",
      description: "Para Walawa, la movilidad urbana es más que un trayecto, es una declaración de intenciones. Realizamos una campaña publicitaria con la realización de fotos y videos que pudieron reflejar la esencia vibrante de la marca. A través de las imágenes dinámicas y estilizadas, destacamos su innovación y carácter único en el mundo del transporte urbano. Con Walawa, te mueves con personalidad.",
      elenco: ["Pamela Ahenke (Fotografia y direccíon creativa)", "Thiago Andrade (Edicíon y actuacíon)"],  // This is an example.
      services: ["Audiovisual", "Marketing", "Tecnologia"]
    },
];

export default portfolios;
